import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import styled from 'styled-components';

interface ISquareTextIcon {
	className?: string;
}

export const DocSquareIcon = styled(({ className }: ISquareTextIcon) => {
	return (
		<div className={className}>
			<TextV2 variant="sans/05/800">DOC</TextV2>
		</div>
	);
})`
	width: 16px;
	height: 16px;
	flex-grow: 0;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 12px;
	padding: 4px 2px;
	border-radius: 2px;
	box-sizing: border-box;
	background-color: ${({ theme }) => theme.v2.color.altLow.blue};
`;

export const NewSquareIcon = styled(({ className }: ISquareTextIcon) => {
	return (
		<div className={className}>
			<TextV2 variant="sans/05/800">NEW</TextV2>
		</div>
	);
})`
	width: 16px;
	height: 16px;
	flex-grow: 0;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 12px;
	padding: 4px 2px;
	border-radius: 2px;
	box-sizing: border-box;
	background-color: ${({ theme }) => theme.v2.color.success[800]};
	${TextV2} {
		color: ${({ theme }) => theme.color.white[500]};
	}
`;

export const ExtensionSquareIcon = styled(
	({ extension, className }: ISquareTextIcon & { extension?: string | null }) => {
		return (
			<div className={className}>
				<TextV2 variant="sans/05/800">{extension?.toUpperCase() ?? 'PDF'}</TextV2>
			</div>
		);
	}
)`
	width: 16px;
	height: 16px;
	flex-grow: 0;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 12px;
	padding: 4px 2px;
	border-radius: 2px;
	box-sizing: border-box;
	background-color: ${({ theme }) => theme.v2.color.altLow.blue};
`;
